/**
 * Ratified maximum number of source rows accepted by one tabular import.
 *
 * Keep browser draining, connected-source reads, and controller validation on
 * this one value. A caller that observes more rows must fail before preview or
 * apply so a truncated prefix can never masquerade as a complete snapshot.
 */
export const MAX_SOURCE_IMPORT_ROWS = 10_000;
